<template>
  <v-content class="create referral page">
    <can I="create" a="Referral">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Referrals', to: '/referrals' },
              { exact: true, text: 'New', to: '/referrals/new' },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>
        </v-toolbar>

        <v-card>
          <v-card-title primary-title class="headline">Create a new Referral</v-card-title>

          <v-alert color="error" transition="scale-transition" :value="referral.errors">
            <ul>
              <li v-for="(message, i) in referral.errors" :key="`error-${i}`">{{ message }}</li>
            </ul>
          </v-alert>

          <v-form @submit.prevent="submit" v-model="valid">
            <v-card-text>
              <OpportunitySelect
                v-model="referral.opportunity"
                :rules="rules.opportunity"
                clearable
                required
              />
              <ProfileSelect clearable required v-model="referral.profile" :rules="rules.profile" />
              <ClientSelect
                v-model="referral.referrer"
                :organization="opportunity.organization"
                :disabled="!referral.opportunity"
                :rules="rules.referrer"
                clearable
                required
              />
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="grey" to="/referrals" flat>
                Cancel
              </v-btn>
              <v-btn color="primary" type="submit" :disabled="!valid">
                Create Referral
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import ClientSelect from '@/components/selects/ClientSelect'
import ProfileSelect from '@/components/selects/ProfileSelect'
import OpportunitySelect from '@/components/selects/OpportunitySelect'

// Vue Component
export default {
  components: { ClientSelect, ProfileSelect, OpportunitySelect },

  data() {
    return {
      referral: {
        opportunity: null,
        profile: {},
        referrer: {},
        errors: null,
      },
      // Validations
      valid: false,
      rules: {
        referrer: [v => !!v || 'must be provided'],
        opportunity: [v => !!v || 'must be provided'],
        profile: [v => !!v || 'must be provided'],
      },
    }
  },
  computed: {
    opportunity() {
      if (!this.referral.opportunity) return {}
      return this.$store.getters['admin/opportunities/find'](this.referral.opportunity)
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('admin/referrals/create', { referral: this.referral }).then(
        ({ data }) => {
          this.$store.dispatch('snackbarSuccess', 'Referral Created')
          this.$router.push('/referrals')
        },
        ({ response }) => {
          this.referral.errors = response.data.errors
          this.$store.dispatch('snackbarError', 'Referral Failed')
        }
      )
    },
  },
}
</script>
